import React, { useState } from 'react';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/Button';

const ResetPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess(true);
      setError(null);
    } catch (err) {
      setError('Erro ao enviar email de recuperação. Verifique o email informado.');
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg max-w-md w-full p-8 space-y-6 border border-purple-100">
        <div className="text-center space-y-2">
          <h2 className="text-2xl font-bold text-gray-900">Recuperar Senha</h2>
          <p className="text-gray-500">Digite seu email para receber o link de recuperação</p>
        </div>

        {error && (
          <div className="bg-red-50 text-red-500 p-3 rounded-lg text-sm">
            {error}
          </div>
        )}

        {success ? (
          <div className="space-y-4">
            <div className="bg-green-50 text-green-600 p-3 rounded-lg text-sm">
              Email de recuperação enviado! Verifique sua caixa de entrada.
            </div>
            <Button onClick={() => navigate('/login')} fullWidth>
              Voltar para Login
            </Button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700" htmlFor="email">
                Email
              </label>
              <div className="relative">
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 border border-purple-200 rounded-lg focus:ring-2 focus:ring-purple-400 focus:border-purple-400 pl-10"
                  placeholder="Digite seu email"
                />
                <Mail className="w-5 h-5 text-purple-400 absolute left-2 top-2.5" />
              </div>
            </div>

            <Button type="submit" fullWidth>
              Enviar Email de Recuperação
            </Button>
          </form>
        )}

        <p className="text-center text-sm text-gray-500">
          Lembrou sua senha?{' '}
          <a href="/login" className="font-medium text-purple-600 hover:text-purple-700">
            Voltar para Login
          </a>
        </p>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
